import moment from "moment";

export interface IIncidents {
  branch: number;
  date: string;
  partnerId?: number | null;
  dateRange?: {
    startDate: number | null;
    endDate: number | null;
  };
  incidentViewMode?: 'pending' | 'resolved' | 'all';
}

export const IncidentsDefaultValues = (): IIncidents => {
  const date = moment.tz("America/Mexico_City").format("YYYY-MM-DD");
  return {
    branch: -99,
    date: date,
    partnerId: null,
    dateRange: {
      startDate: null,
      endDate: null,
    },
    incidentViewMode: 'pending',
  };
};


